import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { createActions } from '../../../../store';
import { WAVE_STYLE } from '../../../../Preview/PreviewDisplayConstants';

const waveStyleOptions = [
    { value: WAVE_STYLE.SOLID, text: 'Solid' },
    { value: WAVE_STYLE.BAR, text: 'Bar' },
    { value: WAVE_STYLE.POINT, text: 'Point' },
    { value: WAVE_STYLE.LINE, text: 'Line' },
];

// Default outline width applied when switching a layer to the Line style so the stroke is visible.
const LINE_DEFAULT_OUTLINE_WIDTH = 3;

const WaveLayerStyleListItem = memo(({ index, waveStyle, currentLayerFillColor, updateWaveLayerCustomOptions, updateWaveLayer }) => {
    const handleChange = useCallback(
        (value) => {
            updateWaveLayerCustomOptions(index, "waveStyle", value);

            // Line has no fill, so give it a visible outline; reset the outline when leaving Line.
            if (value === WAVE_STYLE.LINE) {
                // The Line outline takes THIS layer's own fill colour (snapshot once); it has nothing
                // to do with neighbouring layers. The outline stays editable afterwards.
                updateWaveLayer(index, { lineWidth: LINE_DEFAULT_OUTLINE_WIDTH, lineColor: currentLayerFillColor });
            } else if (waveStyle === WAVE_STYLE.LINE) {
                updateWaveLayer(index, { lineWidth: 0, lineColor: '0x000000' });
            }
        },
        [index, waveStyle, currentLayerFillColor, updateWaveLayerCustomOptions, updateWaveLayer]
    );

    return (
        <ToggleButtonListItem
            text="Style"
            value={waveStyle}
            onChange={handleChange}
            options={waveStyleOptions}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { waveCircles } = state.createPreview.present.videoSettings.visualizer;
    const { waveStyle } = waveCircles[index].customOptions;
    // The Line outline copies this layer's OWN fill colour (per customer: not a neighbour's).
    return { waveStyle, currentLayerFillColor: waveCircles[index].fillColor };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value)),
    updateWaveLayer: (index, properties) => dispatch(createActions.updateWaveLayer(index, properties))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerStyleListItem);
